import { BehaviorSubject, Observable } from 'rxjs';
import { filter, distinctUntilChanged } from 'rxjs/operators';
import { FxDapHttpClient } from '../fx-http-client';
import * as i0 from "@angular/core";
import * as i1 from "../fx-http-client/http/fx-http-client";
// 作业隐藏字段（黑名单）
var FxFieldBlockItem = /** @class */ (function () {
    function FxFieldBlockItem(fieldNo, fieldName) {
        this.fieldNo = fieldNo || '';
        this.fieldName = fieldName || '';
    }
    return FxFieldBlockItem;
}());
// 作业隐藏字段集合（黑名单）
var FxFieldBlackList = /** @class */ (function () {
    function FxFieldBlackList() {
    }
    return FxFieldBlackList;
}());
var FieldAuthorizedService = /** @class */ (function () {
    function FieldAuthorizedService(http) {
        this.http = http;
    }
    /**
     * 設定功能權限資料
     *
     * @param dwAuthorizedId 作業權限ID
     * @param dwActionId 功能按鈕ID
     */
    FieldAuthorizedService.prototype.setActionAuth = function (dwAuthorizedId, dwActionId) {
        var _this = this;
        this.restriction = null;
        this.fieldAuthorizedSubject = new BehaviorSubject(this.restriction);
        var authorizedList; // 作業與功能權限
        this.getProgramHideField(dwAuthorizedId).pipe().subscribe(function (response) {
            authorizedList = response;
            var authorized = authorizedList[dwAuthorizedId];
            if (authorized && authorized.length > 0 && authorized.find(function (item) { return item.fieldNo === dwActionId; })) {
                _this.restriction = 'hidden';
            }
            _this.fieldAuthorizedSubject.next(_this.restriction);
        }, function (error) {
            authorizedList = {};
        });
    };
    Object.defineProperty(FieldAuthorizedService.prototype, "fieldAuthorizedSubject$", {
        /**
         * 提供訂閱功能權限資料
         */
        get: function () {
            return this.fieldAuthorizedSubject.asObservable().pipe(filter(function (obsData) { return obsData !== null; }), // 不廣播初始值
            distinctUntilChanged() // 有改變時才廣播
            );
        },
        enumerable: true,
        configurable: true
    });
    FieldAuthorizedService.prototype.getProgramHideField = function (programId) {
        var _this = this;
        return Observable.create(function (observer) {
            _this.http.post('A/IACommonService/getProgramHideField', { param: { program_no: programId } }).subscribe(function (response) {
                if (response.success && response.data) {
                    observer.next(response.data.map(function (item) { return new FxFieldBlockItem(item.field_no, item.field_name); }));
                }
                else {
                    observer.error();
                }
                observer.complete();
            }, function (error) {
                observer.error();
            });
        });
    };
    FieldAuthorizedService.ngInjectableDef = i0.defineInjectable({ factory: function FieldAuthorizedService_Factory() { return new FieldAuthorizedService(i0.inject(i1.FxDapHttpClient)); }, token: FieldAuthorizedService, providedIn: "root" });
    return FieldAuthorizedService;
}());
export { FieldAuthorizedService };
